import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api from "../../lib/api";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      const res = await api.post("/newsletter/signup", { email });
      toast.success(res.data.message || "Welcome to the VIP list");
      setEmail("");
    } catch (err) {
      toast.error("Could not subscribe");
    } finally {
      setBusy(false);
    }
  };

  return (
    <footer className="bg-poche-black border-t border-white/5 pt-20 pb-10 px-6 md:px-12">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="font-serif text-3xl tracking-luxury text-poche-gold">POCHE</div>
          <p className="text-xs tracking-luxury uppercase text-white/40 mt-2">Joseph Poche · Built For Real Faces</p>
          <p className="text-white/55 mt-8 text-sm leading-relaxed max-w-md">
            A house of luxury eyewear, designed from the bridge outward — for the wider, deeper architecture of real faces.
            From Lagos to the world.
          </p>
          <form onSubmit={subscribe} className="mt-10 flex max-w-md border border-white/15">
            <input
              data-testid="newsletter-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Join the VIP list"
              className="flex-1 bg-transparent px-5 py-4 text-sm placeholder:text-white/35 focus:outline-none focus-gold"
            />
            <button data-testid="newsletter-submit" disabled={busy} className="btn-gold !py-4 !px-6 disabled:opacity-60">
              {busy ? "..." : "Join"}
            </button>
          </form>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-[11px] tracking-luxury uppercase text-poche-gold mb-5">Shop</h4>
          <ul className="space-y-3 text-sm text-white/65">
            <li><Link to="/shop?cat=Sunglasses" className="hover:text-poche-gold">Sunglasses</Link></li>
            <li><Link to="/shop?cat=Optical" className="hover:text-poche-gold">Optical</Link></li>
            <li><Link to="/shop?cat=Sport" className="hover:text-poche-gold">Sport</Link></li>
            <li><Link to="/shop?cat=Golf" className="hover:text-poche-gold">Golf</Link></li>
            <li><Link to="/shop?cat=Women" className="hover:text-poche-gold">Women</Link></li>
            <li><Link to="/legacy" className="hover:text-poche-gold">Legacy Edition</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-[11px] tracking-luxury uppercase text-poche-gold mb-5">House</h4>
          <ul className="space-y-3 text-sm text-white/65">
            <li><Link to="/our-story" className="hover:text-poche-gold">Our Story</Link></li>
            <li><Link to="/fit-guide" className="hover:text-poche-gold">Fit Guide</Link></li>
            <li><Link to="/journal" className="hover:text-poche-gold">Journal</Link></li>
            <li><Link to="/contact" className="hover:text-poche-gold">Concierge</Link></li>
            <li><Link to="/app" className="hover:text-poche-gold">Mobile App</Link></li>
            <li><Link to="/admin/login" className="hover:text-poche-gold">Admin Portal</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-[11px] tracking-luxury uppercase text-poche-gold mb-5">Connect</h4>
          <ul className="space-y-3 text-sm text-white/65">
            <li>concierge@josephpoche.com</li>
            <li>WhatsApp · +1 (212) 555-0177</li>
            <li>Mon — Sun · 09:00 — 21:00 GMT</li>
          </ul>
          <p className="mt-8 text-xs text-white/35 leading-relaxed">
            Authenticity guaranteed. Every POCHE piece ships with a numbered certificate and a 2-year house warranty.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-16 pt-6 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[11px] tracking-luxury uppercase text-white/35">
        <span>© 2026 Joseph Poche Atelier · All rights reserved</span>
        <div className="flex items-center gap-6">
          <span>Privacy</span>
          <span>Terms</span>
          <span>Authenticity</span>
        </div>
      </div>
    </footer>
  );
}
